import { render, staticRenderFns } from "./QuestionsOverview.vue?vue&type=template&id=845aae20&scoped=true"
import script from "./QuestionsOverview.vue?vue&type=script&lang=js"
export * from "./QuestionsOverview.vue?vue&type=script&lang=js"
import style0 from "./QuestionsOverview.vue?vue&type=style&index=0&id=845aae20&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "845aae20",
  null
  
)

export default component.exports